import { render, staticRenderFns } from "./DictadoPorVoz.vue?vue&type=template&id=b4d98104&scoped=true"
import script from "./DictadoPorVoz.vue?vue&type=script&lang=js"
export * from "./DictadoPorVoz.vue?vue&type=script&lang=js"
import style0 from "./DictadoPorVoz.vue?vue&type=style&index=0&id=b4d98104&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d98104",
  null
  
)

export default component.exports